import { render, staticRenderFns } from "./OrderTag.vue?vue&type=template&id=05d80a1d&scoped=true"
import script from "./OrderTag.vue?vue&type=script&lang=js"
export * from "./OrderTag.vue?vue&type=script&lang=js"
import style0 from "./OrderTag.vue?vue&type=style&index=0&id=05d80a1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d80a1d",
  null
  
)

export default component.exports